<template>
  <div class="center__footer__wrapper">
    <div class="rlms-container">
      <div class="group__box">
        <!-- Logo -->
        <div class="logo__box">
          <RouterLink to="/">
            <img :src="newLogo" alt="EESA R APP" />
          </RouterLink>
        </div>

        <!-- Footer Links -->
        <div class="footer__links__box">
          <!-- Phone -->
          <div class="f__mobile">
            <a href="tel:+15705504013">
              <img :src="phoneIcon" alt="EESA R APP" />
              +1 (570) 550-4013
            </a>
          </div>

          <!-- Divider -->
          <img :src="barImg" />

          <!-- Support -->
          <div class="f__support">
            <a href="mailto:info@datamtd.com">
              <img :src="supportIcon" alt="EESA R App Support" />
              info@datamtd.com
            </a>
          </div>

          <!-- Divider -->
          <img :src="barImg" />

          <!-- Privacy Policy -->
          <div class="f__privacy__policy">
            <RouterLink to="/privacy-policy">
              <img :src="supportIcon" alt="Privacy Policy" />
              Privacy Policy
            </RouterLink>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import newLogo from '@/assets/logo.png'
import phoneIcon from '@/assets/images/f-phone.svg'
import barImg from '@/assets/images/verticle-bar-img.png'
import supportIcon from '@/assets/images/support-icon.svg'
</script>